<template>
  <section class="section hero is-light">
    <h1 class="title is-2 is-spaced"> {{content.title}}</h1>
    <div class="container " v-for="item in content.items" :key="item.question">
      <h1 class="title is-4 is-spaced"> {{item.question}}
      </h1>
      <div v-html="item.answer" class="subtitle raw-link"></div>
    </div>
  </section>
</template>

<script>
  import ScheduleBlock from './ScheduleBlock.vue'
  export default {
    name: 'Schedule',
    components: {
      ScheduleBlock
    },
    props: ['content'],

    data: function () {
      return {

      }
    }
  }
</script>

<style scoped>
  .empty-schedule {
    margin: 50px 0px;
  }

  .container {
    max-width: 1000px;
    margin-bottom: 20px;
    margin-top: 20px
  }


  .raw-link >>> a {
    color: hsl(348, 100%, 61%)  !important
  }
</style> 